"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';

interface BlogContextProps {
    hasNext: boolean;
    setHasNext: (value: boolean) => void;
    nextUrl: string;
    setNextUrl: (value: string) => void;
    blogPosts: any[];
    setBlogPosts: (posts: any[]) => void;
    checkedTags: string[];
    setCheckedTags: (tags: string[]) => void;
    count: number;
    setCount: (value: number) => void;
    search: string | null;
    setSearch: (value: string | null) => void;
}

const BlogContext = createContext<BlogContextProps | undefined>(undefined);

export const BlogProvider = ({children}: {children: ReactNode}) => {
    const searchParams = useSearchParams();
    const defaultTag: string[] = [searchParams.get('tag') || 'Career'];

    const [hasNext, setHasNext] = useState(true);
    const [nextUrl, setNextUrl] = useState('');
    const [blogPosts, setBlogPosts] = useState<any[]>([]);
    const [count, setCount] = useState(0);
    const [search, setSearch ] = useState<string | null>(null);

    // Load only career post by default,
    // for now it is should have more priority than other tags, 
    //but later we can make this dynamic
    const [checkedTags, setCheckedTags] = useState<string[]>(defaultTag);

    return (
        <BlogContext.Provider
            value={{
                hasNext,
                setHasNext,
                nextUrl,
                setNextUrl,
                blogPosts,
                setBlogPosts,
                checkedTags,
                setCheckedTags,
                count,
                setCount,
                search,
                setSearch,
            }}
        >
            {children}
        </BlogContext.Provider>
    )
};

export const useBlog = () => {
    const context = useContext(BlogContext);
    if (!context) {
        throw new Error('useBlog must be used within a BlogProvider');
    }
    return context;
};